import classNames from "classnames";
import React, { FC, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";

import { TabsContext } from "./TabsContext";

import Style from "./style.module.scss";

export type TTabItem = {
  label: string;
  element: React.ReactNode;
};

interface IProps {
  tabs: TTabItem[];
  vertical?: boolean;
  defaultActiveIndex?: number;
}

export const Tabs: FC<IProps> = ({
  tabs,
  vertical = false,
  defaultActiveIndex = 0,
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);

  const changeTab = (index: number) => {
    setActiveIndex(index);
  };
  const goNext = () => changeTab(Math.min(activeIndex + 1, tabs.length - 1));

  const goPrev = () => changeTab(Math.max(activeIndex - 1, 0));

  const contextValue = React.useMemo(
    () => ({
      activeIndex,
      tabsCount: tabs?.length || 0,
      goNext,
      goPrev,
      setTab: changeTab,
    }),
    [activeIndex]
  );

  const renderNav = () => (
    <Nav
      tabs={!vertical}
      pills={vertical}
      vertical={vertical}
      className={classNames(
        vertical ? "flex-column ps-2" : "nav-justified ",
        {
          [Style["nav-pills-vertical"]]: vertical,
        }
      )}
    >
      {tabs.map((tab, index) => (
        <NavItem key={index} className="">
          <NavLink
            className={classNames("text-center", {
              active: activeIndex === index,
            })}
            onClick={() => changeTab(index)}
          >
            {tab.label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );

  const navColumn = vertical ? (
    <div className="col-4" style={{ borderLeft: "2px solid #dee2e6" }}>
      {renderNav()}
    </div>
  ) : (
    renderNav()
  );

  const contentColumn = (
    <div className={vertical ? "col-8" : undefined}>
      {tabs[activeIndex]?.element}
    </div>
  );

  return (
    <TabsContext.Provider value={contextValue}>
      {vertical ? (
        <div className="row">
          {navColumn}
          {contentColumn}
        </div>
      ) : (
        <>
          {navColumn}
          {contentColumn}
        </>
      )}
    </TabsContext.Provider>
  );
};
